var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.67,0A1.67,1.67,0,0,0,0,1.67V13.33A1.67,1.67,0,0,0,1.67,15H13.33A1.67,1.67,0,0,0,15,13.33V1.67A1.67,1.67,0,0,0,13.33,0Zm0,1.67H13.33V13.33H9.51V10h2l.3-2.27H9.52V6.31c0-.65.19-1.1,1.13-1.1h1.19v-2A16.9,16.9,0,0,0,10.1,3.1a2.73,2.73,0,0,0-2.92,3V7.76H5.23V10H7.18v3.3H1.67Z"}));
}

Facebook.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = Facebook;

Facebook.default = Facebook;
